exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-app{background-color:#eff2f5}.my-app .recharge-box{background:#fff}.my-app .recharge-box .recharge-ipt{width:90%;height:2.25rem;border:none;font-size:.75rem;padding-left:1rem}.my-app .recharge-des{margin-top:1rem;margin-bottom:1rem;font-size:.65rem;text-align:center}.my-app .recharge-sub{text-align:center}.my-app .recharge-inp{width:80%;background-color:#fff;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;height:2rem;padding-left:.5rem;border:none;font-size:.7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57bc5e6d","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/inpatientRecharge/GoRecharge.vue
// module id = 452
// module chunks = 0